import Cookies from "js-cookie";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getExpirationDate, isExpired } from "./checkExpiredToken";

export const useAuthenticationGuard = () => {
  const location = useLocation();

  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      return;
    }

    const expToken = isExpired(getExpirationDate(token));

    if (expToken) {
      Cookies.remove("token");

      const path = window.location.pathname;
      const languages = path.match(/^\/(en|ua)\//);
      const locale = languages ? `/${languages[1]}` : "";

      window.location.href = `${locale}/login`;
    }
  }, [location.pathname]);
};